import BaseReportStore from './base-store'

import publisherStore from 'modules/offer/stores/publisher'
import siteStore from 'modules/admin/stores/site'
import pathStore from 'modules/path/stores/path'
import pageStore from 'modules/path/stores/page'
import allocationStore from 'modules/offer/stores/allocation'
import pathUserProfileStore from 'modules/path/stores/user_profile'
import OfferStore from 'modules/offer/stores/offer'
import metaFieldStore from 'modules/settings/stores/meta-field'

export default new class ImpressionStore extends BaseReportStore {
  constructor() {
    super(true)
  }

  endpointReport = 'impressions'

  publisher = this.attachEntity(publisherStore)
  path = this.attachEntity(pathStore)
  page = this.attachEntity(pageStore)
  allocation = this.attachEntity(allocationStore, { labelKey: 'description' })
  pathUserProfile = this.attachEntity(pathUserProfileStore)
  offer = this.attachEntity(OfferStore)
  metaField = this.attachEntity(metaFieldStore, {
    labelKey: 'key',
    valueKey: 'key',
    labelFn: ({ value }) => value,
  });
}